// @flow

export const INTERNATIONAL_PASSPORT_NATIONALITIES = ["ru", "ua"]
